<template>
    <div v-title title="收货地址"    class="order_address_overWirte"
         style="height: 88vh;overflow-y: auto;overflow-x: hidden;background-color: #f7f8fa;">

        <!--<van-nav-bar-->
        <!--title="收货地址"-->
        <!--@click-left="onClickLeft">-->
        <!--<span slot="left">-->
        <!--<van-icon name="arrow-left" color="#323233" size="20"/>-->
        <!--</span>-->

        <!--<span slot="right">-->
        <!--<van-icon name="ellipsis" color="#323233" size="20"/>-->
        <!--</span>-->
        <!--</van-nav-bar>-->

        <div class="fapiao_tip1 flex-row">
            <div class="product_img_center2 width10">
                <van-icon size="25" color="#d34236" name="warning-o"/>
            </div>
            <div class="width90">
                <span class="font-red">
                    注意修改地址后影响发货,物流等服务,付款之后仅能修改一次.
                </span>
                <span class="font-color-normal">
                    如商品换仓,已发货,运费等问题导致修改失效请您谅解.
                </span>
            </div>
        </div>


        <div class="width100 bg_white" style="font-size: 2rem;padding-top: 2vh;padding-left: 5vw">
            原地址
        </div>
        <div class="dizhi_box_order_detail" style="margin-top: 0">
            <div class="product_img_center" style="width: 5%">
                <van-icon size="25" name="location-o"/>
            </div>
            <div class="" style="width: 85%;padding-left: 4vw;">
                <div style="font-size: 1.8rem;padding-top: 0.5vh;">
                    {{detail.receiverName}} {{detail.receiverPhone}}
                </div>
                <div style="padding-top: 0.5vh;">
                    {{detail.receiverProvince}}
                    {{detail.receiverCity}}
                    {{detail.receiverRegion}}
                    {{detail.receiverStreet}}
                    {{detail.receiverDetailAddress}}
                </div>
            </div>
        </div>

        <div @click="" class="fuwu_box" style="height: 9vh">
            <div class="flex-row width100" style="padding-top: 1.8vh">
                <div class="width40 text-left font18rem">
                    选择新地址
                </div>
                <div class="width60 text-right font18rem">
                    <span class="lingqu_btn" @click="addAddress">
                        新增地址
                    </span>
                </div>
            </div>
        </div>
        <van-radio-group v-model="submitForm.receiveAddressId">

            <div class="dizhi_box_order_detail bottom_bordr" style="margin-top: 0" v-for="item in dataList"
                 :key="item.id">
                <div class="product_img_center" style="width: 8%">
                    <van-radio :name="item.id" checked-color="#ee0a24"></van-radio>
                </div>
                <div class="" style="width: 85%;padding-left: 4vw;">
                    <div style="font-size: 1.8rem;padding-top: 0.5vh;">
                        {{item.name}} {{item.tel}} <span class="lingqu_btn_juhong" v-if="item.isDefault"
                                                         style="font-size: 1rem;padding: 4px 10px">默认</span>
                    </div>
                    <div style="padding-top: 0.5vh;">
                        {{item.address}}
                    </div>
                </div>
            </div>

        </van-radio-group>

        <div style="position: fixed;bottom: 3vh;width: 90vw;left: 5vw">
            <van-button color="#ee0a24" block @click="updateAddress">
                修改地址
            </van-button>
        </div>
        <div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/orderAddress"></div>
    </div>

</template>

<script>

    export default {
        name: "Order",
        data() {
            return {
                radio: '',
                searchForm: {
                    orderId: ''
                },
                submitForm: {
                    orderId: '',
                    receiveAddressId: '',
                },
                orireceiveAddressId:'',
                detail: {},
                dataList: [],
            };
        },
        created() {
            this.searchForm.orderId = this.$route.query.orderId
            this.getDetail()

            let self = this
            this.$nextTick(() => {
                self.$refs['maidian'].click()
            })
        },
        methods: {
            submit() {

            },
            onClickLeft() {
                if (this.$route.query.formOrderDetail) {
                    this.$router.push({
                        path: '/orderDetail',
                        query: {
                            status: '2',
                            orderId: this.searchForm.orderId
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/orderList',
                        query: {
                            status: '2',
                        }
                    })
                }

            },
            goToDetail() {

            },
            changeAddress() {

            },
            addAddress() {
                this.$router.push("/addressDetail");
            },
            updateAddress() {



                let self = this
                this.submitForm.orderId = this.searchForm.orderId

                if(this.orireceiveAddressId == this.submitForm.receiveAddressId){
                    if (this.$route.query.formOrderDetail) {
                        this.$router.push({
                            path: '/orderDetail',
                            query: {
                                status: '2',
                                orderId: this.searchForm.orderId
                            }
                        })
                    } else {
                        this.$router.push({
                            path: '/orderList',
                            query: {
                                status: '2',
                            }
                        })
                    }

                    return
                }


                let flag = false
                this.dataList.forEach(item => {
                    if (item.id == this.submitForm.receiveAddressId && item.disabled) {
                        flag = true
                    }
                })

                if (flag) {
                    this.$dialog.alert({
                        theme: 'round-button',
                        message: '仅支持修改为['
                            + this.detail.receiverProvince
                            + ']内的地址信息，如需帮助请联系客服.',
                        confirmButtonColor: '#ee0a24'
                    })
                    return
                }

                self.$dialog.confirm({
                    title: '提示',
                    /*theme: 'round-button',*/
                    message: '是否修改收货地址？',
                    confirmButtonColor: '#ee0a24'
                }).then(() => {
                    this.$get('order/updateReceive/' + this.searchForm.orderId, this.submitForm).then((res) => {
                        console.log(res)
                        if (res.code === this.GLOBAL.SUCCESS) {
                            self.$toast('修改收货地址成功');
                            if (this.$route.query.formOrderDetail) {
                                this.$router.push({
                                    path: '/orderDetail',
                                    query: {
                                        status: '2',
                                        orderId: this.searchForm.orderId
                                    }
                                })
                            } else {
                                this.$router.push({
                                    path: '/orderList',
                                    query: {
                                        status: '2',
                                    }
                                })
                            }
                        } else {
                            this.$dialog.alert({
                                theme: 'round-button',
                                message: res.message,
                                confirmButtonColor: '#ee0a24'
                            })
                        }
                    })
                })
            },
            getDetail() {
                this.$get('order/detail/' + this.searchForm.orderId, {}).then((res) => {
                    console.log(res)
                    if (res.code === this.GLOBAL.SUCCESS) {
                        this.detail = res.data
                        this.submitForm.receiveAddressId = this.detail.receiverAddressId
                        this.orireceiveAddressId = this.detail.receiverAddressId

                        this.loadAddress(this.detail.receiverProvince)
                    } else {
                        this.$dialog.alert({
                            theme: 'round-button',
                            message: res.message,
                            confirmButtonColor: '#ee0a24'
                        })
                    }
                })
            },
            loadAddress(receiverProvince) {
                let self = this
                this.$get('member/receiveAddress/list').then((res) => {
                    console.log(res)
                    if (res.code === self.GLOBAL.SUCCESS) {
                        let resData = JSON.parse(JSON.stringify(res.data))
                        resData.forEach(item => {
                            let newItem = {
                                id: '',
                                name: '',
                                tel: '',
                                address: '',
                                isDefault: false,
                                tag: ''
                            }

                            let address = ''
                            if (item.province && item.province != '') {
                                address += item.province
                            }

                            if (item.city && item.city != '') {
                                address += item.city
                            }

                            if (item.region && item.region != '') {
                                address += item.region
                            }

                            if (item.street && item.street != '') {
                                address += item.street
                            }

                            if (item.detailAddress && item.detailAddress != '') {
                                address += item.detailAddress
                            }

                            newItem.id = item.id
                            newItem.name = item.name
                            newItem.tel = self.formatTel(item.phoneNumber)
                            newItem.address = address
                            newItem.tag = item.tag

                            if (item.isDefault == '1') {
                                newItem.isDefault = true
                            } else {
                                newItem.isDefault = false
                            }

                            if (receiverProvince !== item.province) {
                                newItem.disabled = true
                            } else {
                                newItem.disabled = false
                            }

                            self.dataList.push(newItem)

                        })
                    } else {
                        self.$dialog.alert({
                            theme: 'round-button',
                            message: res.message,
                            confirmButtonColor: '#00754a'
                        })
                    }
                })
            },
            formatTel(tel) {
                if (!tel) {
                    return '';
                }
                return tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
            },
        },
    }
</script>
<style>
    .order_detail_overWirte .van-count-down {
        color: #ffffff;
    }
</style>
<style scoped>
    .order_box {
        background: #ffffff;
        width: 100vw;
        min-height: 25vh;
        padding: 0 15px;
        box-sizing: border-box;
        margin-top: 2vh;
    }

    .order_box_row1 {
        width: 100%;
        display: flex;
        flex-direction: row;
        height: 4vh;
        line-height: 4vh;
        padding-top: 10px;
    }

    .order_box_row2 {
        width: 100%;
        display: flex;
        flex-direction: row;
        height: 10vh;
        padding-top: 10px;
    }

    .order_box_row3 {
        width: 100%;
        height: 8vh;
        padding-top: 10px;
    }

    .order_box_row1_col2 {
        background: url("../../../static/images/1451693386449_.pic.jpg") no-repeat;
        background-size: 100%;
        background-position: 1vh;
    }

    .order_box_row3_btn {
        padding: 5px 10px;
    }

    .order_title_box {
        background: url("../../../static/images/order_bg.jpg") no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        width: 100%;
        height: 10vh;
        display: flex;
        flex-direction: row;
        padding: 2vh 5vw 2vh 5vw;
    }

    .fuwu_box {
        width: 100%;
        height: 10vh;
        padding: 1vh 5vw;
        box-sizing: border-box;
        margin-top: 2vh;
        background: #ffffff
    }


</style>



// WEBPACK FOOTER //
// src/view/order/orderAddress.vue